import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksBrigades: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADES,
	},
	getDoneWorksBrigadePreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_PREVIEW,
	},
	getDoneWorksBrigadePopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_POPUP,
	},
	createDoneWorksBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].CREATE_DONE_WORKS_BRIGADE,
	},
	getDoneWorksBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE,
	},
	patchDoneWorksBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PATCH_DONE_WORKS_BRIGADE,
	},
	putDoneWorksBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PUT_DONE_WORKS_BRIGADE,
	},
	deleteDoneWorksBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].DELETE_DONE_WORKS_BRIGADE,
	},
}